/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RadarStagedOrderResponse = {
    parent_order_id: string;
    parent_order_status: RadarStagedOrderResponse.parent_order_status;
    requested_qty: number;
    estimated_amount: number;
    risk_decision: string;
    can_submit: boolean;
};
export namespace RadarStagedOrderResponse {
    export enum parent_order_status {
        STAGED = 'STAGED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        SUBMIT_ATTEMPTED = 'SUBMIT_ATTEMPTED',
    }
}

